import React, { useState, useContext, useEffect } from "react";
import { Outlet } from "react-router";
import Sidebar from "../../../components/Sidebarstr";
import UserContext from "../../../context/UserContext";
import { useLocation, Link } from "react-router-dom";
import FirmList from "../../firms/FirmList";
import Home from "../../Home";

const SalesOfficeMain = () => {
  const { users, setUsers } = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  const items = [{ label: 'Dashboard' ,url: "/", target: '_self'}, { label: 'Sales Office ' }];

  useEffect(() => {
    setUsers((prevUsers) => ({
      ...prevUsers,
      placeSide: "101"
    }));

    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, [setUsers]);

  return (
    <div className={`grid grid-cols-5 gap-4 ${loading ? "hidden" : ""}`}>
    {/* 1. Sütun (Sidebar) */}
    <div
      className={`col-span-1 ${
        loading ? "transform -translate-y-full" : "transform translate-y-0"
      } transition-transform duration-300 ease-out`}
    >
      <Sidebar />
    </div>
    
    {/* 2-5. Sütunlar (Ana İçerik) */}
    
    <div className="col-span-4">
      
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center">
          <p className="text-2xl font-semibold">Loading...</p>
        </div>
        
      )}
     
  
     <nav>
      <ul className="flex border-solid mt-3 rounded-md border-b outline-1">
        {items.map((item, index) => (
          <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
            {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
            {item.url ? (
              <Link to={item.url}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
 
      <Home />
      
      <Outlet />
    </div>
  </div>
  );
};

export default SalesOfficeMain;
